import styled from "styled-components";

import { AmbienteHeader } from "../../pages/Orcamentos/styles";

// Só arranjo: cartão, título, selos e botões são os do design system
// (Orcamentos/styles). Aqui fica o que faz a lista caber na coluna estreita
// do cockpit sem estourar para o lado.

export const ListaDeEnderecos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
`;

export const CabecalhoDoCartao = styled(AmbienteHeader)`
  flex-wrap: wrap;
`;

export const Selos = styled.span`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
`;

export const AcoesDoCartao = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const LinhaDeCobranca = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  color: ${({ theme }) => theme.textPrimary};
  cursor: pointer;
`;

export const RodapeDaLista = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;

export const LinhaSomenteLeitura = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 6px;
`;
